import { getTranslationKeyForDay } from '@/domain/navigation/benachrichtigungen/components/details/shared/getTranslationKeyForDay';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export function Datum({ von, bis }: { von: dayjs.Dayjs; bis?: dayjs.Dayjs }) {
  const { t } = useTranslation();
  if (!bis || von.isSame(bis)) {
    return (
      <span className="text-xs text-neutrals-700">
        {t(getTranslationKeyForDay(von.day()))}., {von.format('DD.MM.YYYY')}
      </span>
    );
  }

  return (
    <span className="text-xs text-neutrals-700">
      {t(getTranslationKeyForDay(von.day()))}., {von.format('DD.MM')}{' '}
      {bis && (
        <span>
          - {t(getTranslationKeyForDay(bis.day()))}., {bis.format('DD.MM.YYYY')}
        </span>
      )}
    </span>
  );
}
